const SERVICE_PROVIDER_CUSTOMER_PREFIX = "service-provider/customer";

const USER_SCOPED_ADMIN_ENDPOINTS = new Set([
  "verify-document",
  "request-document",
  "ucc-reject-document",
  "re-record",
  "upload-general-document",
  "view-property",
]);

export const mapSpCustomerAdminUrl = (
  url,
  userId,
  isServiceProvider = false,
) => {
  if (!isServiceProvider || !url || typeof url !== "string") {
    return url;
  }

  if (!url.startsWith("admin/")) {
    return url;
  }

  const adminPath = url.slice("admin/".length);
  const endpoint = adminPath.split("/")[0];

  if (USER_SCOPED_ADMIN_ENDPOINTS.has(endpoint) && userId) {
    return `${SERVICE_PROVIDER_CUSTOMER_PREFIX}/users/${userId}/${adminPath}`;
  }

  return url.replace(/^admin\//, `${SERVICE_PROVIDER_CUSTOMER_PREFIX}/`);
};

export const mapCreateUserApiUrl = (
  url,
  isServiceProvider = false,
  userId = null,
) => {
  if (!isServiceProvider || !url || typeof url !== "string") {
    return url;
  }

  if (userId) {
    return mapSpCustomerAdminUrl(url, userId, true);
  }

  if (url.startsWith("admin/")) {
    return url.replace(/^admin\//, `${SERVICE_PROVIDER_CUSTOMER_PREFIX}/`);
  }

  // Order summary for Complete Protection (servicer-gated pricing options).
  if (url === "customer/get-final-amount") {
    return `${SERVICE_PROVIDER_CUSTOMER_PREFIX}/get-final-amount`;
  }

  return url;
};

export const mapPaymentApiUrl = (
  path,
  userId,
  isServiceProvider = false,
) => {
  const adminPath = `admin/users/${userId}/${path.replace(/^\//, "")}`;
  return mapCreateUserApiUrl(adminPath, isServiceProvider);
};

/**
 * Where to finish a 3D Secure charge. An SP client checkout (/clients/*) was
 * charged on the owner-checked SP customer route, so it finishes there with
 * the SP token; that lets the backend credit the SP's commission. SP personal
 * payments, Enhanced Monitoring and every other flow keep the public route.
 */
export const resolveCompletePaymentRequest = ({
  path = null,
  selectedCategory,
  isServiceProvider = false,
  isAdminCreateUser = false,
  userId = null,
}) => {
  if (selectedCategory === "enhanced_monitoring") {
    return { url: "complete-payment-enhanced-monitoring", token: false };
  }
  if (path) {
    return { url: `providers/${path}/complete-payment`, token: false };
  }
  if (isServiceProvider && isAdminCreateUser && userId) {
    return {
      url: mapPaymentApiUrl("complete-payment", userId, true),
      token: true,
    };
  }
  return { url: "complete-payment", token: false };
};
